export enum DeviceSize {
  MOBILE = '680px',
  TABLET = '900px',
  LAPTOP = '1440px',
}

export enum DeviceMediaQuery {
  MOBILE = `(max-width: ${DeviceSize.MOBILE})`,
  TABLET = `(max-width: ${DeviceSize.TABLET})`,
  LAPTOP = `(max-width: ${DeviceSize.LAPTOP})`,
}
